import Marquee from "react-fast-marquee";
import { FlowerLotus } from "@phosphor-icons/react";
import { useLang } from "@/i18n";

export default function EditorialMarquee() {
  const { t } = useLang();
  const words = t.marquee.words;
  return (
    <div className="border-y border-forest/10 bg-sage py-6" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {words.map((w) => (
          <span key={w} className="mx-8 flex items-center gap-16">
            <span className="font-serif text-3xl italic text-forest md:text-4xl">{w}</span>
            <FlowerLotus size={22} weight="duotone" className="text-moss" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
